/**
 * Root application component (mirrors web/src/app/App.tsx).
 *
 * Resolves configuration first. If configuration is invalid, the EnvErrorBoundary
 * shows a safe message. Otherwise the AppProviders + Router mount inside the
 * runtime AppErrorBoundary.
 */
import { RouterProvider } from 'react-router-dom';
import { loadConfig } from '@/config/env';
import { AppProviders } from './providers';
import { EnvErrorBoundary } from './EnvErrorBoundary';
import { AppErrorBoundary } from './AppErrorBoundary';
import { router } from './router';

export function App() {
  let configError: Error | null = null;
  try {
    loadConfig();
  } catch (err) {
    configError = err instanceof Error ? err : new Error(String(err));
  }

  return (
    <EnvErrorBoundary error={configError}>
      <AppErrorBoundary>
        <AppProviders>
          <RouterProvider router={router} />
        </AppProviders>
      </AppErrorBoundary>
    </EnvErrorBoundary>
  );
}
